/**
 * Sample terrain for water column analysis at a grid location.
 * Used for 3D Movement Analysis when user clicks a LEK habitat grid cell.
 */
export async function sampleGridTerrain(viewer, centerLon, centerLat, gridSizeKm = 2) {
  if (!viewer || !window.Cesium) {
    throw new Error('Viewer and Cesium required for terrain sampling');
  }

  console.log(`🌊 Sampling terrain for grid at ${centerLat}, ${centerLon}`);
  const halfSize = gridSizeKm / 2;
  const degreeOffset = halfSize / 111; // km to degrees
  const samplePoints = [];
  const samplesPerSide = 5; // 5x5 grid = 25 sample points

  for (let x = 0; x < samplesPerSide; x++) {
    for (let y = 0; y < samplesPerSide; y++) {
      const xOffset = ((x / (samplesPerSide - 1)) - 0.5) * 2 * degreeOffset;
      const yOffset = ((y / (samplesPerSide - 1)) - 0.5) * 2 * degreeOffset;
      const position = window.Cesium.Cartographic.fromDegrees(
        centerLon + xOffset,
        centerLat + yOffset
      );
      samplePoints.push({
        position,
        gridX: x,
        gridY: y,
        longitude: centerLon + xOffset,
        latitude: centerLat + yOffset,
      });
    }
  }

  const cartographicPositions = samplePoints.map((p) => p.position);
  const sampledPositions = await window.Cesium.sampleTerrainMostDetailed(
    viewer.terrainProvider,
    cartographicPositions
  );

  const depthData = [];
  let totalDepth = 0;
  let minDepth = Infinity;
  let maxDepth = -Infinity;
  let validDepthCount = 0;

  for (let i = 0; i < sampledPositions.length; i++) {
    const height = sampledPositions[i].height;
    const depth = height < 0 ? -height : 0;

    depthData.push({
      ...samplePoints[i],
      elevation: height,
      waterDepth: depth,
    });

    if (depth > 0) {
      totalDepth += depth;
      minDepth = Math.min(minDepth, depth);
      maxDepth = Math.max(maxDepth, depth);
      validDepthCount++;
    }
  }

  const avgDepth = validDepthCount > 0 ? totalDepth / validDepthCount : 0;

  return {
    centerLocation: { longitude: centerLon, latitude: centerLat },
    gridSizeKm,
    samplingPoints: depthData,
    summary: {
      averageDepth: avgDepth * 3.28, // Convert to feet
      minDepth: minDepth === Infinity ? 0 : minDepth * 3.28,
      maxDepth: maxDepth === -Infinity ? 0 : maxDepth * 3.28,
      depthVariation:
        maxDepth === -Infinity || minDepth === Infinity
          ? 0
          : (maxDepth - minDepth) * 3.28,
      sampleCount: depthData.length,
      waterSampleCount: validDepthCount,
    },
    timestamp: new Date().toISOString(),
  };
}
